/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UsersService {
    /**
     * Change user password
     * Changes a user's password. Requires current password verification.
     * @param id The ID of the user
     * @param requestBody
     * @returns any Password changed successfully
     * @throws ApiError
     */
    public static patchApiV2UsersChangePassword(
        id: string,
        requestBody: {
            /**
             * User's current password
             */
            currentPassword: string;
            /**
             * New password (must contain uppercase, lowercase, and number)
             */
            newPassword: string;
            /**
             * Confirmation of new password (must match newPassword)
             */
            confirmPassword: string;
        },
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: {
            userid?: number;
            uemail?: string;
            firstname?: string;
            lastname?: string;
            userType?: string;
        };
    }> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v2/users/{id}/change-password',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request (validation error, passwords don't match, or new password same as current)`,
                401: `Unauthorized (current password is incorrect)`,
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get current user
     * Get the currently authenticated user's information including userid, goals (goal_category), and choice (SerOrProd)
     * @returns any Current user retrieved successfully
     * @throws ApiError
     */
    public static getApiV2UsersMe(): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: {
            /**
             * User ID
             */
            userid?: number;
            /**
             * Goal category from user's goals (first active goal, if any)
             */
            goal_category?: string | null;
            /**
             * User's choice (deprecated - always null)
             */
            choice?: string | null;
            uemail?: string;
            firstname?: string;
            lastname?: string;
            userType?: 'BUYER' | 'SUPPLIER' | 'BROWSER';
            goals?: Array<{
                id?: number;
                category?: string;
                activeflag?: boolean;
                cid?: number | null;
            }>;
            is_verified?: boolean;
            profile_complete?: boolean;
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/users/me',
            errors: {
                401: `Unauthorized - Invalid or missing token`,
                404: `User not found in system`,
            },
        });
    }
    /**
     * Update current user
     * Update the currently authenticated user's information
     * @param requestBody
     * @returns any User updated successfully
     * @throws ApiError
     */
    public static patchApiV2UsersMe(
        requestBody: {
            /**
             * User's first name
             */
            firstname?: string;
            /**
             * User's last name
             */
            lastname?: string;
            /**
             * User's email address
             */
            uemail?: string;
            /**
             * User's password (must contain uppercase, lowercase, and number)
             */
            password?: string;
            /**
             * User's role in the system
             */
            userType?: 'BUYER' | 'SUPPLIER' | 'BROWSER';
            /**
             * User's membership plan ID
             */
            membership_id?: number;
            /**
             * User's membership subscription status
             */
            membership_status?: 'ACTIVE' | 'PAST_DUE' | 'CANCELED' | 'TRIALING' | 'INCOMPLETE' | 'INCOMPLETE_EXPIRED' | 'UNPAID' | 'NONE';
            /**
             * User's active status
             */
            isactive?: boolean;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v2/users/me',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get user by ID
     * Retrieves a user by their ID
     * @param id The ID of the user to retrieve
     * @returns any User found successfully
     * @throws ApiError
     */
    public static getApiV2Users(
        id: string,
    ): CancelablePromise<{
        /**
         * User's first name
         */
        firstname: string;
        /**
         * User's last name
         */
        lastname: string;
        /**
         * User's email address
         */
        uemail: string;
        /**
         * User's password (must contain uppercase, lowercase, and number)
         */
        password: string;
        /**
         * User's role in the system
         */
        userType?: 'BUYER' | 'SUPPLIER' | 'BROWSER';
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `User not found`,
            },
        });
    }
    /**
     * Update a user
     * Update one or more fields of a user's information
     * @param id User ID
     * @param requestBody
     * @returns any User updated successfully
     * @throws ApiError
     */
    public static patchApiV2Users(
        id: number,
        requestBody: {
            /**
             * User's first name
             */
            firstname?: string;
            /**
             * User's last name
             */
            lastname?: string;
            /**
             * User's email address
             */
            uemail?: string;
            /**
             * User's password (must contain uppercase, lowercase, and number)
             */
            password?: string;
            /**
             * User's role in the system
             */
            userType?: 'BUYER' | 'SUPPLIER' | 'BROWSER';
            /**
             * User's membership plan ID
             */
            membership_id?: number;
            /**
             * User's membership subscription status
             */
            membership_status?: 'ACTIVE' | 'PAST_DUE' | 'CANCELED' | 'TRIALING' | 'INCOMPLETE' | 'INCOMPLETE_EXPIRED' | 'UNPAID' | 'NONE';
            /**
             * User's active status
             */
            isactive?: boolean;
        },
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: {
            /**
             * User's first name
             */
            firstname: string;
            /**
             * User's last name
             */
            lastname: string;
            /**
             * User's email address
             */
            uemail: string;
            /**
             * User's password (must contain uppercase, lowercase, and number)
             */
            password: string;
            /**
             * User's role in the system
             */
            userType?: 'BUYER' | 'SUPPLIER' | 'BROWSER';
        };
    }> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v2/users/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                404: `User not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Delete a user
     * Deletes a user with the specified ID
     * @param id The ID of the user to delete
     * @returns any User successfully deleted
     * @throws ApiError
     */
    public static deleteApiV2Users(
        id: string,
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v2/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid user ID`,
                401: `Unauthorized - Invalid or missing token`,
                403: `Forbidden - User tried to delete another user's profile`,
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Search users by full name
     * Searches for users by their first and last name
     * @param requestBody
     * @returns any Users retrieved successfully
     * @throws ApiError
     */
    public static postApiV2UsersSearch(
        requestBody: {
            firstname: string;
            lastname: string;
        },
    ): CancelablePromise<{
        status?: boolean;
        data?: Array<{
            /**
             * User's first name
             */
            firstname: string;
            /**
             * User's last name
             */
            lastname: string;
            /**
             * User's email address
             */
            uemail: string;
            /**
             * User's password (must contain uppercase, lowercase, and number)
             */
            password: string;
            /**
             * User's role in the system
             */
            userType?: 'BUYER' | 'SUPPLIER' | 'BROWSER';
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v2/users/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Get certifications for a user
     * Retrieves certifications associated with a user through their locations
     * @param userId User ID
     * @returns any Certifications retrieved successfully
     * @throws ApiError
     */
    public static getApiV2UsersCertifications(
        userId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/users/{userId}/certifications',
            path: {
                'userId': userId,
            },
            errors: {
                400: `User ID not provided`,
            },
        });
    }
}
